import { ApiError, ApiResponse, axiosService } from '@/api/axios';
import { BaseService, Query} from '../base';
import { MaterialResource } from '@/resource/model';
import { getErrorObj, getHttpErrorObj } from '@/utils/handle-request-error';
import { ResourceUrlEnum } from '@/resource/enum';

class MaterialService extends BaseService<MaterialResource> {
  public getList(): Promise<MaterialResource[] | ApiResponse<Partial<MaterialResource>[]>> {
    throw new Error('Method not implemented.');
  }
  public post(): Promise<void> {
    throw new Error('Method not implemented.');
  }
  public put(): Promise<void> {
    throw new Error('Method not implemented.');
  }
  public delete(): Promise<void> {
    throw new Error('Method not implemented.');
  }
  public getById(id: number): Promise<MaterialResource> {
    if (!id) {
      throw new Error('id must not be null');
    }
    throw new Error('Method not implemented.');
  }

  /**
   * 查询所有物料
   */
  public listAll(): Promise<Array<MaterialResource>> {
    throw new Error('Method not implemented.');
  }

  /**
   * 查询已启用
   */
  public listEnable(query: Query<MaterialResource>): Promise<Array<MaterialResource>> {
    return new Promise((resolve, reject) => {
      axiosService
        .post<Array<MaterialResource>>(`${ResourceUrlEnum.material}/listForComponents`, query)
        .then((res: ApiResponse<Array<MaterialResource>>) => {
          if (res.code !== 0) {
            const errorObj: ApiError = getErrorObj(res.code);
            return reject(errorObj);
          }
          resolve(res.data);
        })
        .catch((errorRes: { code: number }) => {
          const errorObj: ApiError = getHttpErrorObj(errorRes.code);
          reject(errorObj);
        });
    });
  }
}

const materialService = new MaterialService();
export default materialService;
